import { useState, useRef } from 'react';
import { daysBetweenDates, isCardTagHidden, formatDay } from '../../../../utils';
import { AlwaysVisibleCardTag, RedDot } from '../../../../components';
import { DraftCommentIcon } from "../../../../components";
import { hasDraft } from "../../../../utils/isDraftHasValue";
import { ContentGroupSettingsNoRedux } from '../../../../components/content_group_settings';

function DesktopCalendarCard(props) {
  const {
    schedule,
    can_destroy,
    can_clone,
    can_update
  } = props;

  const { completed, reminder_in_day, due_date, drafts, unread_comments, stage, visited } = schedule?.raw

  const dateTimeToday = new Date();
  const dateToday = new Date();
  const dueDate = new Date(due_date);
  const past_due = due_date ? dateTimeToday > new Date(due_date) :  false;

  dueDate?.setHours(0,0,0,0);
  dateToday?.setHours(0,0,0,0);

  const diff_in_day = (past_due || due_date === undefined) ? 0 : daysBetweenDates(dateToday, dueDate);

  const isHidden = () => {
    return isCardTagHidden(completed, reminder_in_day, due_date, diff_in_day)
  }

  const has_draft = hasDraft(drafts || []);
  const has_unread_comments = unread_comments?.team || unread_comments?.guest;

  return (
    <div className="d-flex justify-content-between mb-1 position-relative">
      <div className={`desktop-calendar_card-info`}>
        {
          !isHidden() &&
          <AlwaysVisibleCardTag
            completed={completed}
            due_date={due_date}
            reminder_in_day={reminder_in_day}
            diff_in_day={diff_in_day}
            past_due={past_due}
            className={'mb-1'}
            can_access_content={can_update}
          />
        }
        <div className={`d-flex align-items-center mb-1 mr-1 pe-2 content-label__text-container`}>
          <div className={`${visited ? 'text-blue' : ''} content-label__text ${ has_draft ? 'with-draft' : '' } ${ isHidden() ? 'tagged' : '' }`}>
            {schedule.title}
          </div>

          <RedDot className={`mx-1 ${has_unread_comments ? '' : 'd-none'}`} />
          {
            has_draft &&
            <DraftCommentIcon className={'mx-1'}/>
          }

          {
            (can_clone || can_destroy) && !stage.enable_timestamp && <ContentGroupSettingsNoRedux />
          }
        </div>

        <div className="desktop-calendar_card-dueDate">
          {
            formatDay(due_date, 'hh:mm a')
          }
        </div>
      </div>
    </div>
  );
}

export default DesktopCalendarCard;
